export enum ECaptionVariant {
  Default = "default",
  Success = "success",
  Warning = "warning",
  Error = "error",
}
